// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qQrWXeb6Dq4DmqZK6FNc {
  color: var(--primary-dark-blue, #002677);
  font-family: "URW Geometric Ext";
  letter-spacing: -0.1px;
  display: flex;
  justify-content: center;
  min-height: 52px;
}
.qQrWXeb6Dq4DmqZK6FNc .KuYaTSyQIK4yf7Sd9Q0H {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.qQrWXeb6Dq4DmqZK6FNc .KuYaTSyQIK4yf7Sd9Q0H .ZPc_dMGAiH5W_qsM3Sx_ {
  display: flex;
  align-items: center;
}
.qQrWXeb6Dq4DmqZK6FNc .KuYaTSyQIK4yf7Sd9Q0H .ZPc_dMGAiH5W_qsM3Sx_ .AjitBnStcadqUYNDij7g {
  flex-shrink: 0;
  border-radius: 24px;
  background: var(--primary-dark-blue, #002677);
  display: flex;
  width: 20px;
  height: 20px;
  padding: 4px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--primary-white, #fff);
  text-align: center;
  font-weight: 600;
  line-height: 22px;
}
.qQrWXeb6Dq4DmqZK6FNc .KuYaTSyQIK4yf7Sd9Q0H .ZPc_dMGAiH5W_qsM3Sx_ .AjitBnStcadqUYNDij7g span {
  margin-bottom: 3px;
}
.qQrWXeb6Dq4DmqZK6FNc .KuYaTSyQIK4yf7Sd9Q0H .ZPc_dMGAiH5W_qsM3Sx_ .mT1ovYqWjWDSpB_Ien94 {
  padding: 12px 10px;
  font-size: 18px;
  font-weight: 300;
  gap: 12px;
}
.qQrWXeb6Dq4DmqZK6FNc .KuYaTSyQIK4yf7Sd9Q0H .ZPc_dMGAiH5W_qsM3Sx_ .mT1ovYqWjWDSpB_Ien94 .s2VilJOWfkEOsffD177n {
  font-size: 6.5px;
  transition: transform 0.3s ease;
}
.qQrWXeb6Dq4DmqZK6FNc .KuYaTSyQIK4yf7Sd9Q0H .ZPc_dMGAiH5W_qsM3Sx_ .mT1ovYqWjWDSpB_Ien94 .HPpIRSmfcbt5b0X5OlJ0 {
  transform: scaleY(-1);
}
.qQrWXeb6Dq4DmqZK6FNc .KuYaTSyQIK4yf7Sd9Q0H .yxHZe7WJhCrO3VTB2a0O {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
}
.qQrWXeb6Dq4DmqZK6FNc p:last-child,
.qQrWXeb6Dq4DmqZK6FNc > div p:last-child {
  margin-bottom: 0;
}

.LNU_HMketq_LoTfVqQIf {
  display: flex;
  background-color: #f9fafc;
  font-size: 16px;
  padding: 15px 30px 15px 60px;
  margin: 0 0 15px 0;
}
.LNU_HMketq_LoTfVqQIf:last-child {
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .LNU_HMketq_LoTfVqQIf {
    padding: 15px 20px;
  }
}

.oprYNP5lMooApbqi0vTz {
  background: white;
  border-radius: 8px;
  max-width: 90%;
  max-height: 90vh;
  width: 100%;
  margin: 20px;
  display: flex;
  flex-direction: column;
  outline: none;
}
.oprYNP5lMooApbqi0vTz .fUPeN1UfAiQeb9WYrKDs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
}
.oprYNP5lMooApbqi0vTz .fUPeN1UfAiQeb9WYrKDs .hc7Ts1IqhOu60vx3XThb {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--primary-dark-blue, #002677);
}
.oprYNP5lMooApbqi0vTz .fUPeN1UfAiQeb9WYrKDs .Lu21AC2TdsuR6hpuWE2o {
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.oprYNP5lMooApbqi0vTz .fUPeN1UfAiQeb9WYrKDs .Lu21AC2TdsuR6hpuWE2o i {
  font-size: 20px;
}
.oprYNP5lMooApbqi0vTz .gouVtl42PiC7R4DgCeXD {
  overflow-y: auto;
  flex: 1;
}
.oprYNP5lMooApbqi0vTz .gouVtl42PiC7R4DgCeXD p:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/react/components/Notices/Notices.module.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;EACA,gCAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;AACN;AAAM;EACE,cAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAER;AADQ;EACE,kBAAA;AAGV;AAAM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAER;AAAQ;EACE,gBAAA;EACA,+BAAA;AAEV;AAAQ;EACE,qBAAA;AAEV;AAGI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AADN;AAKE;;EAEE,gBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;AAJF;AAME;EACE,gBAAA;AAJJ;AAOE;EAXF;IAYI,kBAAA;EAJF;AACF;;AAQA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AALF;AAOE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AALJ;AAOI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,wCAAA;AALN;AAQI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AANN;AAQM;EACE,eAAA;AANR;AAWE;EACE,gBAAA;EACA,OAAA;AATJ;AAWI;EACE,gBAAA;AATN","sourcesContent":[".notice__block {\r\n  color: var(--primary-dark-blue, #002677);\r\n  font-family: 'URW Geometric Ext';\r\n  letter-spacing: -0.1px;\r\n  display: flex;\r\n  justify-content: center;\r\n  min-height: 52px;\r\n\r\n  .notice__main__and__secondary {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n\r\n    .main__block {\r\n      display: flex;\r\n      align-items: center;\r\n      .number {\r\n        flex-shrink: 0;\r\n        border-radius: 24px;\r\n        background: var(--primary-dark-blue, #002677);\r\n        display: flex;\r\n        width: 20px;\r\n        height: 20px;\r\n        padding: 4px 0px;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-items: center;\r\n        color: var(--primary-white, #fff);\r\n        text-align: center;\r\n        font-weight: 600;\r\n        line-height: 22px;\r\n        span {\r\n          margin-bottom: 3px;\r\n        }\r\n      }\r\n      .btn {\r\n        padding: 12px 10px;\r\n        font-size: 18px;\r\n        font-weight: 300;\r\n        gap: 12px;\r\n\r\n        .arrow {\r\n          font-size: 6.5px;\r\n          transition: transform 0.3s ease;\r\n        }\r\n        .rotate {\r\n          transform: scaleY(-1);\r\n        }\r\n      }\r\n    }\r\n\r\n    .notice__expand {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      padding-bottom: 30px;\r\n    }\r\n  }\r\n\r\n  p:last-child,\r\n  > div p:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.noteCard {\r\n  display: flex;\r\n  background-color: #f9fafc;\r\n  font-size: 16px;\r\n  padding: 15px 30px 15px 60px;\r\n  margin: 0 0 15px 0;\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  @media (max-width: 991.98px) {\r\n    padding: 15px 20px;\r\n  }\r\n}\r\n\r\n// Mobile modal styles\r\n.notice__modal {\r\n  background: white;\r\n  border-radius: 8px;\r\n  max-width: 90%;\r\n  max-height: 90vh;\r\n  width: 100%;\r\n  margin: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  outline: none;\r\n\r\n  .notice__modal__header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 20px 24px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n\r\n    .modal__title {\r\n      margin: 0;\r\n      font-size: 20px;\r\n      font-weight: 600;\r\n      color: var(--primary-dark-blue, #002677);\r\n    }\r\n\r\n    .btn-clear {\r\n      padding: 8px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n\r\n      i {\r\n        font-size: 20px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .notice__modal__body {\r\n    overflow-y: auto;\r\n    flex: 1;\r\n\r\n    p:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notice__block": `qQrWXeb6Dq4DmqZK6FNc`,
	"notice__main__and__secondary": `KuYaTSyQIK4yf7Sd9Q0H`,
	"main__block": `ZPc_dMGAiH5W_qsM3Sx_`,
	"number": `AjitBnStcadqUYNDij7g`,
	"btn": `mT1ovYqWjWDSpB_Ien94`,
	"arrow": `s2VilJOWfkEOsffD177n`,
	"rotate": `HPpIRSmfcbt5b0X5OlJ0`,
	"notice__expand": `yxHZe7WJhCrO3VTB2a0O`,
	"noteCard": `LNU_HMketq_LoTfVqQIf`,
	"notice__modal": `oprYNP5lMooApbqi0vTz`,
	"notice__modal__header": `fUPeN1UfAiQeb9WYrKDs`,
	"modal__title": `hc7Ts1IqhOu60vx3XThb`,
	"btn-clear": `Lu21AC2TdsuR6hpuWE2o`,
	"notice__modal__body": `gouVtl42PiC7R4DgCeXD`
};
export default ___CSS_LOADER_EXPORT___;
